<template>
    <div>
        <div v-if='text' v-html="text"></div>

        <b-button v-html="text_button" v-if="type_button" :variant="type_button" @click="action"></b-button>
    </div>

</template>

<script>
    import _ from 'lodash';
	import * as json2csv from "json2csv";

    const vm = require('vm');
    var clone = require("clone");

    import treatments from "../../services/treatments.js";
	import database from "../../services/database.js";

    export default {
        props: {
            format: {
                default: "small"
            },
            user: {
                default: () => {}
            },
            config: {
                default: () => {}
            },
            test_jwt: {
                default: null
            }
        },
        data: function () {
            return {
                text: "",
                type_button: "",
                text_button: "",
                code: "",
                columns_db: [],
                project: "",
            };
		},
		methods: {
            async action()
            {
                console.log(" - action - ");

                var data = clone(this.user)

                console.log(data)

                var context = {
                    console: console,
                    data: data
                };

                data = vm.runInNewContext(`
                        fu = function (data){
                            ${this.code};
                            return data}; 
                        data = fu(data); data;
                    `, context);
                
                console.log(data)
                console.log(this.columns_db)

                if (this.columns_db && this.columns_db.length > 0)
                {
                    var where = "";
                    if (this.config.user_table_uid_column)
                        where = "`" + this.config.user_table_uid_column + "` = '" + this.user.uid + "'";
                    else if (this.config.user_table_identifiant_column)
                        where = "`" + config.user_table_identifiant_column + "` = '" + this.user.identifiant + "'"                    

                    if (where)
                    {
                        var request = "";
						for (var j = 0; j < this.columns_db.length; j++) {
                            if (j > 0) 
                                request += ",";
							var cell = data[this.columns_db[j]];
                            if (cell == null || cell == "null") 
                                cell = "NULL";
							else if (typeof cell == "string")
								cell = '"' + cell.replace(/"/g, '\\"') + '"';
							request += "`" + this.columns_db[j] + "` = " + cell + " ";
						}

                        console.log({
                            where: where,
                            set: request
                        })

                        var response = await database.get("update", this.config.user_table, {
                            where: where,
                            set: request
                        }, this.test_jwt);
                    }
                }    
                
                this.$emit("action");

                if (this.project)
                {
                    data = json2csv.parse([data], {
						fields: Object.keys(data),
						fieldNames: Object.keys(data),
					});

					data = new Blob([data], {
						type: "text/plain",
					});

					var formData = new FormData();

					var treatment_data = await treatments.create(
						this.project,
						null,
						data,
						"data.csv",
						null,
						"import",
						formData
					).catch((err) => {
                        console.log("error : " + err);
                        this.$notify({
                            group: "info",
                            title: err.response.data.msg,
                            type: "error",
                        });
                    });
                }
            },
            async load(data)
            {
                this.data = data;

                console.log(this.data)

                if (this.format == 'small')
                {
                    this.text = this.data.text_small ? this.data.text_small.replace(/\n/g, "<br />") : "";
                    this.type_button = this.data.type_button_small;
                    this.text_button = this.data.text_button_small ? this.data.text_button_small.replace(/\n/g, "<br />") : "";
                }
                else
                {
                    this.text = this.data.text_big ? this.data.text_big.replace(/\n/g, "<br />") : "";
                    this.type_button = this.data.type_button_big;
                    this.text_button = this.data.text_button_big ? this.data.text_button_big.replace(/\n/g, "<br />") : "";
                }

                this.code = data.code;
                this.columns_db = data.columns_db;
                this.project = data.project;

                var compiled = _.template(this.text);
                this.text = compiled({  });

                var compiled = _.template(this.text_button);
                this.text_button = compiled({  });
            }
		},
		mounted: function () {

		},
    }


</script>